export default {"src":"/_next/static/media/minillus-discount.b3823281.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};